export default __webpack_public_path__ + "static/media/assessment_glide_6_1.f488a8c5.svg";